import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';
import { useIsS12nDataLoading } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';

export type TwoPanelConversationalDiscoveryExperimentContextType = {
  twoPanelConversationalDiscoveryEnabled: boolean;
  chatOnLeft: boolean;
  chatOnRight: boolean;
};

export const TwoPanelConversationalDiscoveryExperimentContext =
  createContext<TwoPanelConversationalDiscoveryExperimentContextType>({
    twoPanelConversationalDiscoveryEnabled: false,
    chatOnLeft: false,
    chatOnRight: false,
  });

function TwoPanelConversationalDiscoveryExperimentProvider({ children }: React.PropsWithChildren) {
  const isS12nDataLoading = useIsS12nDataLoading();
  const [value] = useState(() => {
    const variant = GrowthDiscoveryEpicClient.get('twoPanelConversationalDiscoveryOnXdp');
    return {
      twoPanelConversationalDiscoveryEnabled: variant !== 'control',
      chatOnLeft: variant === 'C',
      chatOnRight: variant === 'B',
    };
  });

  return (
    <TwoPanelConversationalDiscoveryExperimentContext.Provider value={value}>
      {value.twoPanelConversationalDiscoveryEnabled ? (
        <CoachStateProvider coachOpen={true} isContextConfigLoading={isS12nDataLoading}>
          {children}
        </CoachStateProvider>
      ) : (
        children
      )}
    </TwoPanelConversationalDiscoveryExperimentContext.Provider>
  );
}

export const useTwoPanelConversationalDiscoveryExperiment = () => {
  return useContext(TwoPanelConversationalDiscoveryExperimentContext);
};

export default TwoPanelConversationalDiscoveryExperimentProvider;
